import { secureRoute } from '@uag/react-core';import { Route, Routes } from 'react-router-dom';

import { Home } from './Home';
import { NotFound } from './NotFound';
import { Unauthorized } from './Unauthorized';

const SecureHome = secureRoute(Home);

export const AppRoutes = () => {
    return (
        <Routes>
            <Route Component={SecureHome} path="" />
            <Route Component={Unauthorized} path="/unauthorized" />
            <Route Component={NotFound} path="*" />
        </Routes>
    );
};
